// extracted by mini-css-extract-plugin
export default {"Opps":"opps_Opps__Bv4rP","OppsButton":"opps_OppsButton__ZMmMT","text":"opps_text__wSIpz"};